/* ==========================================================================
   BioBird — homepage interactions
   Scroll reveals · counters · cursor light · parallax · magnetic buttons
   tilt cards · sticky glass nav · particles · before/after · FAQ
   Bundle builder · review filters · AJAX cart
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch  = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var motion = !reduce && !touch;

  document.addEventListener('DOMContentLoaded', init);
  // Re-bind when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);

  function init() {
    themeToggle();
    mobileDrawer();
    scrollProgress();
    reveals();
    counters();
    cursorLight();
    magnetic();
    tilt();
    stickyNav();
    particles();
    beforeAfter();
    faq();
    bundle();
    reviewFilters();
    qtySteppers();
    pdp();
    product3D();
    videoBanners();
    cartCount();
  }

  /* ------------------------------------------------- day / night mode ---- */
  function themeToggle() {
    var btn = document.getElementById('bb-theme-toggle');
    var root = document.documentElement;

    // enable colour transitions only after first paint
    requestAnimationFrame(function () { document.body && document.body.classList.add('bb-theming'); });

    // follow the OS when the visitor hasn't chosen manually
    if (false && window.matchMedia) {
      var mq = window.matchMedia('(prefers-color-scheme: dark)');
      var onSys = function (e) {
        if (localStorage.getItem('bb-theme')) return;
        root.setAttribute('data-bb-theme', e.matches ? 'dark' : 'light');
      };
      if (mq.addEventListener) mq.addEventListener('change', onSys);
      else if (mq.addListener) mq.addListener(onSys);
    }

    if (!btn || btn.dataset.bbBound) return;
    btn.dataset.bbBound = '1';
    btn.addEventListener('click', function () {
      var next = root.getAttribute('data-bb-theme') === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-bb-theme', next);
      try { localStorage.setItem('bb-theme', next); } catch (e) {}
      btn.setAttribute('aria-pressed', String(next === 'dark'));
    });
  }

  /* ----------------------------------------------------- mobile drawer --- */
  function mobileDrawer() {
    var burger = document.getElementById('bb-burger');
    var drawer = document.getElementById('bb-drawer');
    if (!burger || !drawer || drawer.dataset.bbBound) return;
    drawer.dataset.bbBound = '1';

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('bb-lock');
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('bb-lock');
    }

    burger.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* -------------------------------------------------- scroll progress ---- */
  function scrollProgress() {
    var bar = document.querySelector('#bb-progress i');
    if (!bar || window.__bbProgress) return;
    window.__bbProgress = true;
    var raf = null;
    function upd() {
      raf = null;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var p = max > 0 ? (h.scrollTop || window.scrollY) / max : 0;
      bar.style.width = (p * 100).toFixed(2) + '%';
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* ------------------------------------------- 3D product on scroll ------ */
  function product3D() {
    var tracks = [].slice.call(document.querySelectorAll('.bb-p3d:not([data-bb-bound])'));
    if (!tracks.length) return;

    tracks.forEach(function (sec) {
      sec.setAttribute('data-bb-bound', '');
      var track  = sec.querySelector('.bb-p3d__track');
      var obj    = sec.querySelector('.bb-p3d__obj');
      var frames = [].slice.call(sec.querySelectorAll('[data-frame]'));
      var points = [].slice.call(sec.querySelectorAll('.bb-p3d__point'));
      if (!track || (!obj && !frames.length)) return;

      var spin = parseFloat(sec.getAttribute('data-spin') || '34'); // total deg swing
      var raf  = null;

      function render() {
        raf = null;
        var r = track.getBoundingClientRect();
        var vh = window.innerHeight;
        // progress 0..1 across the tall track while it's pinned
        var total = r.height - vh;
        var p = total > 0 ? Math.min(Math.max((-r.top) / total, 0), 1) : 0;

        if (frames.length) {
          // image-sequence scrub (360-style)
          var idx = Math.min(frames.length - 1, Math.floor(p * frames.length));
          frames.forEach(function (f, i) { f.style.opacity = i === idx ? '1' : '0'; });
        } else if (obj) {
          var deg = (p - 0.5) * spin;
          var lift = Math.sin(p * Math.PI) * 14;
          obj.style.transform =
            'rotateY(' + deg.toFixed(2) + 'deg) rotateX(' + (lift * 0.2).toFixed(2) + 'deg) translateY(' + (-lift).toFixed(1) + 'px)';
        }

        // reveal feature points in sequence
        points.forEach(function (pt, i) {
          var at = points.length > 1 ? i / points.length : 0;
          pt.classList.toggle('is-on', p >= at * 0.92);
        });
      }

      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(render); }, { passive: true });
      window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(render); }, { passive: true });
      render();
    });
  }

  /* ------------------------------------------------- video banners ------- */
  function videoBanners() {
    // lazy-load + play/pause when off-screen; wire mute buttons
    [].slice.call(document.querySelectorAll('.bb-vbanner__media video:not([data-bb-bound])')).forEach(function (v) {
      v.setAttribute('data-bb-bound', '');
      v.muted = true; v.playsInline = true;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.2 });
        io.observe(v);
      } else {
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }

      var frame = v.closest('.bb-vbanner__frame');
      var mute  = frame && frame.querySelector('.bb-vbanner__mute');
      if (mute && !mute.dataset.bbBound) {
        mute.dataset.bbBound = '1';
        mute.addEventListener('click', function () {
          v.muted = !v.muted;
          mute.setAttribute('aria-pressed', String(!v.muted));
          mute.querySelector('[data-on]').style.display  = v.muted ? 'none' : '';
          mute.querySelector('[data-off]').style.display = v.muted ? '' : 'none';
          if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        });
      }
    });
  }

  /* ---------------------------------------------------------- reveals ---- */
  function reveals() {
    var els = [].slice.call(document.querySelectorAll('.bb-reveal:not([data-bb-seen])'));
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-bb-seen', ''); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { el.setAttribute('data-bb-seen', ''); io.observe(el); });
  }

  /* --------------------------------------------------------- counters ---- */
  function counters() {
    var els = [].slice.call(document.querySelectorAll('.bb-count:not([data-bb-seen])'));
    if (!els.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el     = e.target;
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        io.unobserve(el);

        if (reduce) { el.textContent = target + suffix; return; }

        var dur = 1400, start = performance.now();
        (function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { el.setAttribute('data-bb-seen', ''); io.observe(el); });
  }

  /* ----------------------------------------- cursor light + parallax ----- */
  function cursorLight() {
    if (!motion || window.__bbCursorBound) return;
    window.__bbCursorBound = true;

    var mx = 0, my = 0, raf = null;

    function apply() {
      raf = null;
      var cursor = document.getElementById('bb-cursor');
      if (cursor) {
        cursor.style.opacity = '1';
        cursor.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      }
      var dx = mx - window.innerWidth / 2;
      var dy = my - window.innerHeight / 2;
      [].slice.call(document.querySelectorAll('[data-parallax]')).forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-parallax')) || 0;
        el.style.transform = 'translate(' + (dx * f).toFixed(2) + 'px,' + (dy * f).toFixed(2) + 'px)';
      });
    }

    window.addEventListener('mousemove', function (ev) {
      mx = ev.clientX; my = ev.clientY;
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
  }

  /* -------------------------------------------------------- magnetic ----- */
  function magnetic() {
    if (!motion) return;
    [].slice.call(document.querySelectorAll('[data-magnetic]:not([data-bb-bound])')).forEach(function (btn) {
      btn.setAttribute('data-bb-bound', '');
      btn.classList.add('bb-mag');
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.3) + 'px,' + (y * 0.4) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = 'translate(0,0)'; });
    });
  }

  /* ------------------------------------------------------------ tilt ----- */
  function tilt() {
    if (!motion) return;
    [].slice.call(document.querySelectorAll('[data-tilt]:not([data-bb-bound])')).forEach(function (card) {
      card.setAttribute('data-bb-bound', '');
      card.classList.add('bb-tilt');
      var max = card.hasAttribute('data-tilt-strong') ? 14 : 6;

      card.addEventListener('mousemove', function (e) {
        var r  = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width  - 0.5;
        var py = (e.clientY - r.top)  / r.height - 0.5;
        card.style.transition = 'transform .08s linear';
        card.style.transform =
          'perspective(900px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1)';
        card.style.transform  = 'perspective(900px) rotateY(0) rotateX(0) translateY(0)';
      });
    });
  }

  /* ------------------------------------------------------- sticky nav ---- */
  function stickyNav() {
    var nav = document.getElementById('bb-nav');
    if (!nav || nav.hasAttribute('data-bb-bound')) return;
    nav.setAttribute('data-bb-bound', '');

    function onScroll() { nav.classList.toggle('is-stuck', window.scrollY > 40); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------- particles ---- */
  function particles() {
    var field = document.getElementById('bb-particles');
    if (!field || !motion || field.childElementCount) return;

    var n = parseInt(field.getAttribute('data-count') || '22', 10);
    for (var i = 0; i < n; i++) {
      var p = document.createElement('div');
      var size = 3 + Math.random() * 5;
      p.style.cssText =
        'position:absolute;border-radius:50%;' +
        'background:rgba(95,139,116,' + (0.15 + Math.random() * 0.3).toFixed(2) + ');' +
        'width:' + size.toFixed(1) + 'px;height:' + size.toFixed(1) + 'px;' +
        'left:' + (Math.random() * 100).toFixed(1) + '%;top:' + (Math.random() * 100).toFixed(1) + '%;' +
        '--dx:' + ((Math.random() - 0.5) * 120).toFixed(0) + 'px;' +
        '--dy:' + (-60 - Math.random() * 160).toFixed(0) + 'px;' +
        'animation:bbDrift ' + (8 + Math.random() * 10).toFixed(1) + 's linear ' +
        (Math.random() * 8).toFixed(1) + 's infinite';
      field.appendChild(p);
    }
  }

  /* ---------------------------------------------------- before / after --- */
  function beforeAfter() {
    var win = document.getElementById('bb-ba');
    if (!win || win.hasAttribute('data-bb-bound')) return;
    win.setAttribute('data-bb-bound', '');

    var top    = document.getElementById('bb-ba-top');
    var handle = document.getElementById('bb-ba-handle');
    if (!top || !handle) return;

    var dragging = false;

    function setPct(clientX) {
      var r = win.getBoundingClientRect();
      var pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(4, Math.min(96, pct));
      top.style.width   = pct + '%';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
    }

    function point(e) { return e.touches ? e.touches[0].clientX : e.clientX; }

    win.addEventListener('mousedown',  function (e) { dragging = true; setPct(point(e)); });
    win.addEventListener('touchstart', function (e) { dragging = true; setPct(point(e)); }, { passive: true });
    window.addEventListener('mousemove', function (e) { if (dragging) setPct(point(e)); }, { passive: true });
    window.addEventListener('touchmove', function (e) { if (dragging) setPct(point(e)); }, { passive: true });
    window.addEventListener('mouseup',  function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });

    // keyboard access
    handle.addEventListener('keydown', function (e) {
      var cur = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft')  { cur -= 4; }
      else if (e.key === 'ArrowRight') { cur += 4; }
      else { return; }
      e.preventDefault();
      cur = Math.max(4, Math.min(96, cur));
      top.style.width = cur + '%';
      handle.style.left = cur + '%';
    });
  }

  /* ------------------------------------------------------------- FAQ ----- */
  function faq() {
    [].slice.call(document.querySelectorAll('.bb-faq__item:not([data-bb-bound])')).forEach(function (item) {
      item.setAttribute('data-bb-bound', '');
      var q = item.querySelector('.bb-faq__q');
      var a = item.querySelector('.bb-faq__a');
      if (!q || !a) return;

      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        q.setAttribute('aria-expanded', String(!open));
        a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
      });
    });
  }

  /* -------------------------------------------------- bundle builder ----- */
  function bundle() {
    var root = document.querySelector('.bb-bundle__card:not([data-bb-bound])');
    if (!root) return;
    root.setAttribute('data-bb-bound', '');

    var slots   = [].slice.call(root.querySelectorAll('.bb-slot'));
    var picker  = root.querySelector('.bb-bundle__picker');
    var totalEl = root.querySelector('[data-bundle-total]');
    var saveEl  = root.querySelector('[data-bundle-save]');
    var addBtn  = root.querySelector('[data-bundle-add]');
    if (!picker || !addBtn) return;

    var discount = parseFloat(root.getAttribute('data-discount') || '20') / 100;
    var active   = null;          // slot currently being filled
    var chosen   = {};            // slotIndex -> { id, price, title, img }

    slots.forEach(function (slot, i) {
      slot.addEventListener('click', function () {
        active = i;
        picker.classList.add('is-open');
        picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    [].slice.call(picker.querySelectorAll('.bb-pick')).forEach(function (pick) {
      pick.addEventListener('click', function () {
        if (active === null) active = slots.findIndex(function (s) { return !s.classList.contains('is-filled'); });
        if (active < 0) active = 0;

        chosen[active] = {
          id:    pick.getAttribute('data-variant'),
          price: parseInt(pick.getAttribute('data-price'), 10),
          title: pick.getAttribute('data-title'),
          img:   pick.getAttribute('data-img')
        };

        var slot = slots[active];
        slot.classList.add('is-filled');
        slot.innerHTML =
          (chosen[active].img
            ? '<span class="bb-slot__img"><img src="' + chosen[active].img + '" alt=""></span>'
            : '') +
          '<span>' + chosen[active].title + '</span>';

        picker.classList.remove('is-open');
        active = null;
        recalc();
      });
    });

    function recalc() {
      var keys = Object.keys(chosen);
      var sum  = keys.reduce(function (t, k) { return t + chosen[k].price; }, 0);
      var pay  = Math.round(sum * (1 - discount));

      if (totalEl) totalEl.textContent = money(pay);
      if (saveEl)  saveEl.textContent  = money(sum - pay);

      addBtn.disabled = keys.length < slots.length;
      addBtn.textContent = keys.length < slots.length
        ? 'Pick ' + (slots.length - keys.length) + ' more'
        : 'Add bundle · ' + money(pay);
    }

    addBtn.addEventListener('click', function () {
      var items = Object.keys(chosen).map(function (k) {
        return { id: chosen[k].id, quantity: 1 };
      });
      if (!items.length) return;
      addToCart(items, addBtn);
    });

    recalc();
  }

  /* ------------------------------------------------- review filters ------ */
  function reviewFilters() {
    var wrap = document.querySelector('.bb-reviews__filters:not([data-bb-bound])');
    if (!wrap) return;
    wrap.setAttribute('data-bb-bound', '');

    var pills   = [].slice.call(wrap.querySelectorAll('[data-filter]'));
    var reviews = [].slice.call(document.querySelectorAll('.bb-review'));

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tag = pill.getAttribute('data-filter');
        pills.forEach(function (p) { p.classList.toggle('bb-pill--active', p === pill); });
        reviews.forEach(function (r) {
          var tags = (r.getAttribute('data-tags') || '').toLowerCase();
          r.classList.toggle('is-hidden', tag !== 'all' && tags.indexOf(tag.toLowerCase()) === -1);
        });
      });
    });
  }

  /* ---------------------------------------------------------- cart ------- */
  // Quick-add buttons anywhere on the page
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    if (!id) return;
    addToCart([{ id: id, quantity: 1 }], btn);
  });

  /* ----------------------------------------------------- qty steppers ---- */
  function qtySteppers() {
    document.querySelectorAll('.bb-qty').forEach(function (box) {
      if (box.dataset.bbBound) return;
      box.dataset.bbBound = '1';

      var input = box.querySelector('input');
      if (!input) return;

      box.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty'), 10) || 0;
          var min  = parseInt(input.getAttribute('min'), 10);
          if (isNaN(min)) min = 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------- pdp ----- */
  function pdp() {
    /* gallery thumbs */
    var main = document.querySelector('.bb-pdp__main img');
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
      if (btn.dataset.bbBound) return;
      btn.dataset.bbBound = '1';

      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-pdp-thumb');
        main.removeAttribute('srcset');
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
      });
    });

        /* mobile swipe gallery */
    var galleryThumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));
    var gallerySurface = main && main.closest('.bb-pdp__main');
    if (gallerySurface && galleryThumbs.length > 1 && !gallerySurface.dataset.bbSwipeBound) {
      gallerySurface.dataset.bbSwipeBound = '1';
      gallerySurface.style.touchAction = 'pan-y';
      main.draggable = false;

      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipePointerId = null;

      gallerySurface.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && !window.matchMedia('(max-width: 749px)').matches) return;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
      }, { passive: true });

      gallerySurface.addEventListener('pointerup', function (event) {
        if (swipePointerId !== event.pointerId) return;

        var distanceX = event.clientX - swipeStartX;
        var distanceY = event.clientY - swipeStartY;
        swipePointerId = null;

        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.15) return;

        var currentIndex = galleryThumbs.findIndex(function (button) {
          return button.classList.contains('is-on');
        });
        if (currentIndex < 0) currentIndex = 0;

        var direction = distanceX < 0 ? 1 : -1;
        var nextIndex = (currentIndex + direction + galleryThumbs.length) % galleryThumbs.length;
        galleryThumbs[nextIndex].click();

        if (main.animate) {
          main.animate([
            { opacity: 0.55, transform: 'translateX(' + (direction * 16) + 'px) scale(0.985)' },
            { opacity: 1, transform: 'translateX(0) scale(1)' }
          ], {
            duration: 260,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
          });
        }
      }, { passive: true });

      gallerySurface.addEventListener('pointercancel', function () {
        swipePointerId = null;
      }, { passive: true });
    }

    /* variant selection */
    var form = document.getElementById('bb-pdp-form');
    var data = document.querySelector('[data-pdp-variants]');
    if (!form || !data || form.dataset.bbBound) return;
    form.dataset.bbBound = '1';

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-pdp-option]');
    var idField = form.querySelector('[data-pdp-id]');
    var addBtn  = form.querySelector('[data-pdp-add]');
    var priceEl = document.querySelector('[data-price]');
    var compEl  = document.querySelector('[data-compare]');

    selects.forEach(function (sel) {
      sel.addEventListener('change', pick);
    });

    function pick() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });

      var match = variants.filter(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      })[0];

      if (!match) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Unavailable';
        }
        return;
      }

      if (idField) idField.value = match.id;

      if (priceEl) priceEl.textContent = money(match.price);
      if (compEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compEl.textContent = money(match.compare_at_price);
          compEl.style.display = '';
        } else {
          compEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.querySelector('span').textContent = match.available ? 'Add to bag' : 'Sold out';
      }

      /* keep the URL shareable */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }
  }

  /* Format cents using the shop's money format where available. */
  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency: fmt, minimumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '₹' + (cents / 100).toFixed(0);
    }
  }

  function addToCart(items, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; }
        cartCount(true);
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        }, 1600);
        document.dispatchEvent(new CustomEvent('bb:cart:updated'));
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
      });
  }

  function cartCount(refresh) {
    var el = document.querySelector('[data-cart-count]');
    if (!el || !refresh) return;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { el.textContent = c.item_count; });
  }

  // Shopify.routes fallback for older themes
  window.Shopify = window.Shopify || {};
  window.Shopify.routes = window.Shopify.routes || { root: '/' };
})();
